import React, { useEffect, useState } from "react";
import { message, Form, Button, Card, AutoComplete, Input, Typography, Col, Row } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, Link } from "react-router-dom";
import axios from 'axios';
import FAQs from "./FAQ";
import HeaderBanner from "./HeaderBanner";

import {
    hideMessage,
    showAuthLoader,
    resetAuthStore
} from "./../appRedux/actions/Auth";

import IntlMessages from "util/IntlMessages";
import CircularProgress from "components/CircularProgress/index";
import { getSchoolListUrl } from "../constants/AppConstants";
import { showMessage as commonMessage } from "../appRedux/actions/Common";
import { searchedSchool, selectedSchool } from "../analytics";
const { Text } = Typography;

const Schools = () => {

    const dispatch = useDispatch();
    const { loader, alertMessage, showMessage, authUser } = useSelector(({ auth }) => auth);
    const [] = Form.useForm();
    const history = useHistory();
    const [pincode, setPincode] = useState("");
    const [school, setSchool] = useState()
    const [schoolList, setSchoolList] = useState([])
    const [datasource, setDatasource] = useState([])
    useEffect(() => {
        if (showMessage) {
            setTimeout(() => {
                dispatch(hideMessage());
            }, 100);
        }
        if (authUser && authUser.username) {
            history.push('/');
        }
    });
    useEffect(() => {
        localStorage.removeItem('school')
        document.body.style = "overflow:scroll"
    }, []);
    const onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
    };

    const onFinish = () => {
        // dispatch(showAuthLoader());
        // if (showOTP) {
        //     return dispatch(verifyUserPhoneNumber({ cognitoUser, otp }));
        // }
        // dispatch(signInCognitoUser(values));
        localStorage.setItem('school', school)
        selectedSchool(pincode, school.id, school.name)
        history.push(`/signup?school_id=${school.id}&school_name=${school.name}`)
    };
    const handleSearch = (value) => {
        //setSchoolList(value)
    }
    const pincodeUpdated = (value) => {
        console.log(value)
        setPincode(value)
        if (`${value}`.length === 6) {
            dispatch(showAuthLoader());
            searchedSchool(pincode);
            (async () => {
                let schoolList = []
                setSchool(null)
                try {
                    const url = getSchoolListUrl(value)
                    schoolList = await (await axios.get(url)).data
                    // const response = await fetch(,{mode: 'no-cors'})
                    console.log(schoolList)
                } catch (error) {
                    schoolList = []
                    setDatasource([])
                    dispatch(commonMessage("No schools found"))

                    return
                }
                if (!schoolList || !schoolList.length) {
                    setTimeout(() => {
                        dispatch(commonMessage("No schools found"))
                    }, 500);
                    setSchool(null)
                }
                setSchoolList(schoolList)
                setDatasource(schoolList.map((item) => {
                    return {
                        value: `${item.name}`,
                        label: (
                            <div>{item.name}
                                <p>
                                    <Text disabled>{item.address}</Text>
                                </p>
                            </div>
                        )
                    };
                }));
                dispatch(hideMessage());
            })()
        }

    }
    return (
        <Col>
            <div className="gx-app-school-screen">
                <HeaderBanner></HeaderBanner>
                <div className="gx-app-login-wrap">

                    <div className="gx-app-login-container">
                        <div className="gx-app-login-main-content">
                            <div className="gx-app-logo-content">
                                <div className="gx-app-logo-content-bg">

                                    <img src={require("assets/images/bg-website-final.png")} alt='background' />
                                </div>
                                <div className="gx-app-logo-wid">
                                    <h1>Make practice fun for your students</h1>
                                    <p>Free tools for teachers to assign curriculum aligned Math and Science quizzes.
Available for teachers in CBSE & ICSE Class 6- 10.</p>
                                    <p></p>
                                    <p>Select your school to see how your students are performing.</p>
                                    {/* <p><IntlMessages id="app.userAuth.getAccount"/></p> */}
                                </div>
                                <div className="gx-app-logo">
                                    <img alt="example" src={require("assets/images/quiznext-logo-white@2x.png")} />
                                </div>
                            </div>
                            <div className="gx-app-login-content">
                                <Form
                                    initialValues={{ phone: "" }}
                                    name="basic"
                                    onFinish={onFinish}
                                    onFinishFailed={onFinishFailed}
                                    className="gx-signin-form gx-form-row0">
                                    <Card className="gx-card" title="Select School">
                                        <Form.Item
                                            initialValue=""
                                            rules={[{ required: true, message: 'Enter Postal Pincode' }]} name="pincode" >
                                            <Input type="number" placeholder="Enter Postal Pincode" onChange={(elem) => { pincodeUpdated(elem.target.value) }} />
                                        </Form.Item>
                                        <Row style={{ marginTop: "-15px", marginBottom: "5px" }}>
                                            <div className="gx-tag-style-subject-medium">eg. 110038 for Gurgaon</div>
                                            <div className="gx-tag-style-subject-medium">Enter 999999 for locations outside India</div>
                                        </Row>
                                        {(schoolList && schoolList.length) ? <AutoComplete
                                            options={datasource}
                                            style={{ width: "100%", marginBottom: 20 }}
                                            onSelect={(value) => {
                                                const selectedSchool = schoolList.filter(s => s.name == value)[0]
                                                setSchool(selectedSchool)
                                                //console.log(selectedSchool)
                                            }
                                            }
                                            value={school ? school.name : ""}
                                            onSearch={handleSearch}
                                            placeholder="Select School"
                                        /> : ""}
                                        {school && school.id === "00000000" && <Form.Item rules={[{ required: true, message: 'Enter School Name' }]} name="school_name" >
                                            <Input placeholder="Enter school name" onChange={(e) => {
                                                const school_updated = { ...school, name: `${e.target.value}_${pincode}` }
                                                setSchool(school_updated)
                                            }} />
                                        </Form.Item>}
                                    </Card>
                                    <Form.Item>
                                        <Button type="primary" className="gx-mb-0" htmlType="submit" disabled={!school}>
                                            <IntlMessages id={"app.userAuth.selectSchool"} />
                                        </Button>
                                        <Link
                                            to="/signin"
                                            onClick={() => {
                                                dispatch(resetAuthStore());
                                            }}
                                            style={{ paddingRight: 10 }}
                                        >
                                            Already have a account? Sign In.
                                    </Link>
                                    </Form.Item>
                                    <Link
                                        onClick={() => {
                                            window.tidioChatApi && window.tidioChatApi.popUpOpen();

                                        }}
                                    >
                                        Need help with signup?
                                    </Link>
                                </Form>
                            </div>

                            {loader ?
                                <div className="gx-loader-view">
                                    <CircularProgress />
                                </div> : null}
                            {showMessage ?
                                message.error(alertMessage.toString()) : null}
                        </div>
                    </div>

                </div>
                <FAQs />
            </div>
        </Col>
    );
};

export default Schools;
